import Enum from "./Enum";

export default Enum.create( {
	REGULARLY_SCHEDULED_TEAM_MEETING: "REGULARLY_SCHEDULED_TEAM_MEETING",
	DAILY_STANDUP: "DAILY_STANDUP",
	SET_TEAM_GOALS: "SET_TEAM_GOALS",
	TEAM_RETROSPECTIVE: "TEAM_RETROSPECTIVE",
	// All-State templates
	ALLSTATE_WEEKLY_TEAM_MEETING: "ALLSTATE_WEEKLY_TEAM_MEETING",
} );
